/**
 * Email validation regex, inlined from the internal `@wix/wix-js-validations` package
 * (`regular-expressions.ts`) so the published bundle has no private-registry dependency.
 * Kept byte-for-byte equivalent (see `email-regex.spec.ts`) so guest-comment validation
 * does not change.
 */
const anyLetter = '¡-퟿-￿-a-zA-Z';
const anyDigit = '0-9';
const anyLetterOrDigit = `${anyLetter}${anyDigit}`;
const anyAllowedSymbol = "!#$%&'*+/=?^_`{|}~-";
const allowedWithoutQuotes = `[${anyLetterOrDigit}${anyAllowedSymbol}]+(?:\\.[${anyLetterOrDigit}${anyAllowedSymbol}]+)*`;
const allowedBetweenQuotes = '"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*"';
const localPart = `(?:${allowedWithoutQuotes}|${allowedBetweenQuotes})`;
const domainPart = `(?:[${anyLetterOrDigit}](?:[${anyLetterOrDigit}-]*[${anyLetterOrDigit}])?\\.)+(?:(?:[${anyDigit}]+[${anyLetter}][${anyLetterOrDigit}]*)|(?:[${anyLetter}][${anyLetterOrDigit}]{1,}))`;
export const emailRegex = new RegExp(`^${localPart}@${domainPart}$`);
//# sourceMappingURL=email-regex.js.map